/* eslint-disable react/no-danger */
/* global googleMapsKey */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { pick, isEqual } from 'lodash';
import { htmlDecode } from 'htmlencode';
import { CONTENT_COMPONENT_TYPE } from '@liswood-tache/browsbox-static';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from 'react-google-maps';

export const MAP_STYLES = {
  default: { value: '', title: 'standaard' },
  grayscale: { value: 'grayscale', title: 'zwart wit' },
};

const propTypes = {
  address: PropTypes.string,
  classes: PropTypes.string,
  containerClassName: PropTypes.string,
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  mapStyle: PropTypes.string,
  mapZoom: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  markerTitle: PropTypes.string,
  markerValue: PropTypes.string,
  type: PropTypes.string,
};

const defaultProps = {
  address: '',
  classes: '',
  containerClassName: '',
  latitude: '50.8251460',
  longitude: '4.3110560',
  mapStyle: MAP_STYLES.DEFAULT,
  mapZoom: 15,
  markerTitle: '',
  markerValue: '',
  type: CONTENT_COMPONENT_TYPE.googleMaps,
};

const loadingElementStyles = {
  height: '100%',
};
const containerElementStyles = {
  height: '314px',
};
const mapElementStyles = {
  height: '100%',
};
const googleMapStyles = {
  grayscale: [{
    featureType: 'all',
    stylers: [
      { saturation: -100 },
      { gamma: 1 },
    ],
  }],
  // need 'default' to switch from mapStyle 'grayscale' to ''
  default: [{
    featureType: 'all',
    stylers: [],
  }],
};

// Wrap react-google-maps GoogleMap component here because of required props
// that should otherwise be passed to ContentGoogleMaps.
class GoogleMapsDetail extends Component {
  constructor(props) {
    super(props);
    this.onToggleOpen = this.onToggleOpen.bind(this);
    this.state = {
      isOpen: true,
      mapChanged: false,
    };
  }

  componentDidUpdate(prevProps) {
    const paths = ['latitude', 'longitude', 'mapStyle'];
    const prev = pick(prevProps, paths);
    const current = pick(this.props, paths);

    if (!isEqual(prev, current)) {
      // eslint-disable-next-line
      this.setState({ mapChanged: (new Date()).getTime() });
    }
  }

  onToggleOpen() {
    const newIsOpen = !this.state.isOpen;
    this.setState({ isOpen: newIsOpen });
  }

  render() {
    const {
      latitude,
      longitude,
      mapZoom,
      markerTitle,
      mapStyle,
    } = this.props;
    const {
      isOpen,
      mapChanged,
    } = this.state;

    // Google maps styled map (grayscale, ...)
    const defaultOptions = {
      styles: googleMapStyles[mapStyle] || googleMapStyles.default,
    };

    if (typeof latitude === 'string' && typeof longitude === 'string') {
      const lat = parseFloat(latitude);
      const lng = parseFloat(longitude);
      const location = { lat, lng };
      return (
        <GoogleMap
          defaultZoom={mapZoom}
          defaultCenter={location}
          defaultOptions={defaultOptions}
          key={mapChanged}
        >
          <Marker position={location} onClick={this.onToggleOpen}>
            { isOpen && <InfoWindow onCloseClick={this.onToggleOpen}>
              <div dangerouslySetInnerHTML={{ __html: markerTitle }} />
            </InfoWindow> }
          </Marker>
        </GoogleMap>
      );
    }
    return null;
  }
}

GoogleMapsDetail.propTypes = {
  latitude: PropTypes.string.isRequired,
  longitude: PropTypes.string.isRequired,
  markerTitle: PropTypes.string.isRequired,
  mapZoom: PropTypes.number.isRequired,
  mapStyle: PropTypes.string.isRequired,
};

const ContentGoogleMapsDetail = withScriptjs(withGoogleMap(GoogleMapsDetail));

const ContentGoogleMaps = (props) => {
  const {
    address,
    classes,
    containerClassName,
    latitude,
    longitude,
    mapStyle,
    mapZoom,
    markerTitle: markerTitleEncoded,
    markerValue,
    type,
  } = props;

  const isMarkerShown = false;
  const componentClasses = classNames(
    classes,
    containerClassName,
    `c-${type}`,
  );
  const markerTitle = htmlDecode(markerTitleEncoded);
  return (
    <div
      className={componentClasses}
      data-lat={latitude}
      data-lon={longitude}
      data-address={address}
      data-markervalue={markerValue}
      data-markertitle={markerTitle}
      data-map-style={mapStyle}
      data-zoom={mapZoom}
    >
      <ContentGoogleMapsDetail
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&libraries=places`}
        isMarkerShown={isMarkerShown}
        loadingElement={<div style={loadingElementStyles} />}
        containerElement={<div style={containerElementStyles} />}
        mapElement={<div style={mapElementStyles} />}
        latitude={latitude}
        longitude={longitude}
        mapZoom={+mapZoom}
        markerTitle={markerTitle}
        mapStyle={mapStyle}
      />
    </div>
  );
};

ContentGoogleMaps.propTypes = propTypes;
ContentGoogleMaps.defaultProps = defaultProps;

export default ContentGoogleMaps;



// WEBPACK FOOTER //
// ./src/components/Content/ContentComponents/ContentComponentGoogleMaps.js